import { createMatchSelector } from 'connected-react-router';
import { connect } from 'react-redux';
import { compose, path, pipe } from 'ramda';

import SidebarRecentReports from 'components/SidebarRecentReports';
import withPageLoader from 'components/withPageLoader';

import { SUPER_RESEARCHER, SUPER_TECHNICIAN } from 'constants/userRoles';
import { getUserRole, isTechnician, getUserId, isDoctor } from 'store/selectors/user';

import {
  getReportsShouldShowLoading,
  getSortedRecentReportsForTechnician,
} from 'store/selectors/reports/recent';
import { requestReports } from 'store/actionCreators/reports/recent';

const mapStateToProps = (state, ownProps) => {
  const id = path(['match', 'params', 'id'], ownProps);
  return {
    data: getSortedRecentReportsForTechnician(id)(state),
    isDoctor: isDoctor(state),
    isAvailableCreateReport: isTechnician(state),
  };
};

export default compose(
  withPageLoader({
    loadingSelector: (state, ownProps) => {
      const patientId = path(['match', 'params', 'id'], ownProps);
      return getReportsShouldShowLoading(patientId)(state);
    },
    initialAction: requestReports,
    initialActionArgsSelector: state => {
      const patientId = pipe(
        createMatchSelector('/patient/:reportId'),
        path(['params', 'reportId']),
      )(state);
      const role = getUserRole(state);
      const isSuperRole = [SUPER_RESEARCHER, SUPER_TECHNICIAN].includes(role);
      const performer = getUserId(state);

      return {
        patientId,
        ...(!isSuperRole && { performer }),
      };
    },
  }),
  connect(mapStateToProps),
)(SidebarRecentReports);
